import React from 'react';
import recarxlogoneg from '../assets/images/logo512neg.png';
/*import recarxlogo from '../assets/images/Recarx_Plus_v1.png';*/
import { Phone, Mail, MapPin, Instagram } from 'lucide-react'; // Car, Twitter, Youtube, Facebook
import openWhatsApp from '../utils/whatsapp';

export const Footer: React.FC = () => {
  // Configuración WhatsApp (desde .env con fallbacks)
  const phoneEnv = process.env.REACT_APP_WHATSAPP_NUMBER || '';
  const phone = phoneEnv.replace(/\D/g, '') || '584225555500';
  const chatMessage = process.env.REACT_APP_MESSAGE_CHAT || 'Quiero información de Recarx Plus. ¿Me pueden ayudar?';

  return (
    <footer  id="contacto" className="scroll-mt-6 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src={recarxlogoneg}
                alt="Recarx Plus Logo"
                className="h-14 w-14 object-contain"
                style={{ display: 'block' }}
              />
              <div>
                <h1 className="text-xl font-bold">RECARX PLUS</h1>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              La plataforma de diagnóstico y soluciones automotrices que en un clic conecta a conductores con servicios de Atención Primaria de Mecánica a domicilio o especializada en taller.  Ya disponibles en Caracas, Lara y Valencia, de lunes a viernes, entre las 8:00 am y 5:00 pm.
            </p>
            <div className="flex space-x-4">
              {/*
              <a href="https://www.instagram.com/recarxplus/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              */}
              <a href="https://www.instagram.com/recarxplus/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Servicios</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Atención Primaria de Mecánica a domicilio o en taller
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Diagnóstico mecánico
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Ruta segura
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Segunda opinión técnica
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Empresa</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Forma parte de la red de aliados
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Centro de ayuda
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Términos y condiciones
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Política de privacidad
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contacto</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-blue-400 mt-0.5" />
                <div>
                  <p className="text-white font-medium">Línea de consulta</p>
                  <p className="text-gray-300"> Caracas +58 422 RECARX0 (7322790)</p>
                  <p className="text-gray-300"> Lara +58 0422 3665063</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-blue-400 mt-0.5" />
                <div>
                  <p className="text-white font-medium">Email</p>
                  <p className="text-gray-300">recarxplus@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-400 mt-0.5" />
                <div>
                  <p className="text-white font-medium">Oficina principal</p>
                  <p className="text-gray-300">Caracas, Venezuela</p>
                </div>
              </div>
            </div>

            <div className="mt-6 p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-2">¿Necesitas ayuda?</h4>
              <p className="text-sm text-gray-300 mb-3">
                Nuestro chat está disponible 8/5
              </p>
              <button
                type="button"
                onClick={() => openWhatsApp(phone, chatMessage)}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-medium transition-colors"
                aria-label="Iniciar chat por WhatsApp"
              >
                Iniciar Chat
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 RECARX PLUS. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                Políticas
              </a>
              <a href="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookies
              </a>
              <a href="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};